import { Pipe, PipeTransform } from '@angular/core';
import type { CashSession } from '../../../../data/src/lib/entities/treasury.model';

const SYSTEM_PERSON_ID = '10000000-0000-0000-0000-000000000000';
const SYSTEM_PERSON_DISPLAY_NAME = 'Sistema';
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

@Pipe({ name: 'cashSessionClosedByLabel', standalone: true, pure: true })
export class CashSessionClosedByLabelPipe implements PipeTransform {
  transform(
    session: CashSession,
    personNameById?: ReadonlyMap<string, string>,
  ): string {
    const raw = (session.ClosedBy ?? '').trim();
    if (!raw) return '—';
    if (raw.toLowerCase() === SYSTEM_PERSON_ID) {
      return SYSTEM_PERSON_DISPLAY_NAME;
    }
    const named = personNameById?.get(raw);
    if (named) return named;
    if (UUID_RE.test(raw)) return '—';
    return raw;
  }
}
